module.exports = __webpack_public_path__ + "img/skinxs-logo-small-black.2fec66d4.svg";